import { FunctionComponent } from 'react'
import { Box, Grid, TextField, Button } from '@mui/material'
import { Cached, Search } from '@mui/icons-material'
import styled from '@emotion/styled'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const StyledButton = styled(Button)({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '4px',
  height: '48px',
  padding: '14px',
  textDecoration: 'none',
  transition: 'all 0.4s ease 0s',
  '& svg': {
    color: '#fff',
    fontSize: '20px',
  },
})

interface Props {
  setFilter: (name: string) => void
}

export const PurchasePlansDetailFilters: FunctionComponent<Props> = ({
  setFilter,
}) => {
  const { register, handleSubmit, reset } = useForm<{ name: string }>({
    defaultValues: {
      name: '',
    },
  })
  const { t } = useTranslation()

  const onSubmit = (values: { name: string }) => {
    setFilter(values.name)
  }

  const handleReset = () => {
    reset()
    setFilter('')
  }

  return (
    <>
      <form id="purchase-plan-detail-filter-form" onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            margin: '32px 0',
            position: 'relative',
          }}
        >
          <Grid
            container
            justifyContent="space-between"
            rowGap="10px"
            columnGap={{ xs: 0, md: '10px' }}
            sx={{
              padding: '20px',
              border: '1px solid #e1e4e8',
              borderRadius: '4px',
            }}
          >
            <Grid
              item
              xs={9}
              md={'auto'}
              sx={{
                flexGrow: '1 !important',
              }}
            >
              <TextField
                id="search"
                placeholder={t('products-sevice-names')}
                variant="outlined"
                fullWidth
                sx={{
                  maxHeight: '48px',
                  '& .MuiInputBase-input': {},
                  '& fieldset': {},
                }}
                {...register('name')}
              />
            </Grid>
            <Grid item xs={3} md={'auto'}>
              <Box display="flex" justifyContent="flex-end" gap="10px">
                <StyledButton
                  sx={{
                    background: 'rgb(122, 127, 126)',
                    '&:hover': {
                      background: 'rgb(135, 141, 140)',
                    },
                  }}
                  type="submit"
                  form="purchase-plan-detail-filter-form"
                >
                  <Search />
                </StyledButton>
                <StyledButton
                  sx={{
                    background: 'rgb(3, 34, 76)',
                    color: '#fff',
                    '&:hover': {
                      background: 'rgba(3, 34, 76, 0.6)',
                    },
                  }}
                  onClick={handleReset}
                >
                  <Cached />
                </StyledButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </form>
    </>
  )
}
